export default __webpack_public_path__ + "static/media/heart-circle-tc.2e031984.svg";